import { mutate } from 'swr'

import {
  fetchFile,
  postJson,
  putJson,
  requestDelete,
  requestDeleteBatchWithBody,
} from '../../../../../data/fetchers'
import { DeliveryForecastDespatchAdvicePackagingMaterial } from '../../../../../data/models'

export async function requestUpdatePackagingMaterial(
  id: string,
  dto: DeliveryForecastDespatchAdvicePackagingMaterial,
) {
  await putJson(`/masterdata/packagingdata/${id}`, dto)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/masterdata/packagingdata`.toLowerCase()),
  )
}

export async function requestCreatePackagingMaterial(
  dto: DeliveryForecastDespatchAdvicePackagingMaterial,
) {
  await postJson(`/masterdata/packagingdata`, dto)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/masterdata/packagingdata`.toLowerCase()),
  )
}

export async function requestDeletePackagingMaterial(id: string) {
  await requestDelete(`/masterdata/packagingdata/${id}`)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/masterdata/packagingdata`.toLowerCase()),
  )
}

export async function requestDeletePackagingMaterials(
  packagingMaterialIds: string[],
): Promise<any> {
  const result = await requestDeleteBatchWithBody(
    `/masterdata/packagingdata/batch`,
    packagingMaterialIds,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/masterdata/packagingdata`.toLowerCase()),
  )

  return result
}

export async function requestDownloadPackagingMaterial(
  culture: string = 'DE-de',
) {
  const url = `/masterdata/packagingdata/$download?csvCulture=${culture}`

  return await fetchFile(url)
}

export async function requestPrepareUploadablePackagingMaterial(
  csv: File,
  csvCulture: string = 'DE-de',
  reusablePackagingFrom: string = 'reusablePackaging',
  disposablePackagingFrom: string = 'disposablePackaging',
  deleteExistingPackages: boolean = false,
  tareUnit?: string,
  measureUnit?: string,
  volumeUnit?: string,
  reusablePackagingTo?: string,
  disposablePackagingTo?: string,
): Promise<DeliveryForecastDespatchAdvicePackagingMaterial[]> {
  let query = `?csvCulture=${csvCulture}&deleteExistingPackages=${deleteExistingPackages.toString()}`

  if (tareUnit) query = `${query}&tareUnit=${tareUnit}`
  if (measureUnit) query = `${query}&measureUnit=${measureUnit}`
  if (volumeUnit) query = `${query}&volumeUnit=${volumeUnit}`
  if (reusablePackagingTo)
    query = `${query}&reusablePackagingTo=${reusablePackagingTo}`
  if (reusablePackagingFrom)
    query = `${query}&reusablePackagingFrom=${reusablePackagingFrom}`
  if (disposablePackagingTo)
    query = `${query}&disposablePackagingTo=${disposablePackagingTo}`
  if (disposablePackagingFrom)
    query = `${query}&disposablePackagingFrom=${disposablePackagingFrom}`

  const formData = new FormData()
  formData.append('file', csv)

  const result = await postJson(
    `/masterdata/packagingdata/batch/$preparecsv${query}`,
    formData,
  )

  return result
}

export async function requestUploadPackagingMaterial(
  data: DeliveryForecastDespatchAdvicePackagingMaterial[],
  deleteExistingPackages: boolean = false,
) {
  let query = `?deleteExistingPackages=${deleteExistingPackages.toString()}`

  const result = await postJson(`/masterdata/packagingdata/batch${query}`, data)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/masterdata/packagingdata`.toLowerCase()),
  )

  return result
}
